<template>
  <div>
    <div class="container-fluid">
      <div
        origin-left="true"
        transition-duration="1s"
        item-selector=".item"
        origin-top="true"
        :horizontal-order="true"
        class="row mb-5 results-container"
        style="margin: 0px 25px; background-color: transparent"
      >
        <div
          class="item card-body mb-4 col-lg-3"
          v-for="(attraction, index) in Attractions"
          :key="index"
          style="background: transparent"
        >
          <router-link
            v-if="attraction.eventDate"
            :to="`/upcoming-events/${attraction.slug}`"
            class="filter-link-wrapper"
          >
            <div class="image-wrapper-attractions">
              <span
                class="trip-number"
                v-if="attraction.eventDate"
                >{{
                  convertToDate(attraction.eventDate)
                    .toLocaleDateString('en-US', {
                      month: '2-digit',
                      day: '2-digit',
                      year: 'numeric',
                    })
                    .replaceAll('/', '-')
                }}</span
              >
              <span
                class="trip-number"
                v-if="attraction.tripId == ''"
                >Trip No. {{ attraction.id }}</span
              >
              <figure
                class="location-image-container"
                v-if="attraction.imageUrl"
              >
                <b-img-lazy
                  class="location-image"
                  :alt="attraction.title"
                  :src="attraction.imageUrl"
                />
              </figure>
            </div>
            <div
              class="body-tx"
              :data-publish="attraction.publish"
            >
              <h3>
                {{ attraction.title }}
              </h3>
            </div>
          </router-link>
          <router-link
            v-else
            :to="`/places-to-go/${attraction.slug}`"
            class="filter-link-wrapper"
          >
            <div class="image-wrapper-attractions">
              <span
                class="trip-number"
                v-if="attraction.eventDate"
                >{{ attraction.eventDate }}</span
              >
              <span
                class="trip-number"
                v-if="attraction.tripId == ''"
                >Trip No. {{ attraction.id }}</span
              >
              <figure
                class="location-image-container"
                v-if="attraction.imageUrl"
              >
                <b-img-lazy
                  class="location-image"
                  :alt="attraction.title"
                  :src="attraction.imageUrl"
                />
              </figure>
            </div>
            <div
              class="body-tx"
              :data-publish="attraction.publish"
            >
              <h3>
                {{ attraction.title }}
              </h3>
            </div>
          </router-link>
        </div>
      </div>
    </div>
    <div
      class="col-lg-12 mt-3"
      v-if="Attractions != ''"
    >
      <router-link
        class="button"
        :to="getLink()"
      >
        Show Me More <span> > </span>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    Attractions: {
      type: [Array],
    },
    convertToDate: {
      type: Function,
    },
    getLink: {
      type: Function,
    },
  },
};
</script>

<style lang="scss" scoped>
a {
  color: #173945;

  &:hover,
  &:focus-visible {
    text-decoration: none;
  }

  &:visited {
    color: #4d5a67;
  }
}

h3 {
  font-size: 1.1rem;
}
.results-container {
  margin-top: 1rem !important;
}
.filter-link-wrapper {
  background: #FFFFFF;
  border: 1px solid transparent;
  border-radius: 8px;
  box-shadow: 0 0 1px 0 rgba(10, 22, 70, 0.06),
    0 6px 6px -1px rgba(10, 22, 70, 0.10);
  display: block;
  overflow: hidden;
}
.image-wrapper-attractions {
  position: relative;
}
span.trip-number {
  position: absolute;
  bottom: 0px;
  left: 20px;
  background-color: #173945;
  color: #fff;
  padding: 5px 10px;
  font-weight: 700;
  font-size: .8rem;
}
.location-image-container {
  align-items: center;
  display: flex;
  height: 275px;
  justify-content: center;
  overflow: hidden;
}
.location-image {
  object-fit: contain;
  max-height: 475px;
}

.body-tx {
  font-size: 24px;
  padding: 20px;
  text-align: left;
}
a.button {
  color: #ffffff;
  display: inline-block;
}
</style>
